<template>
  <header class="app-header">
    <div class="header-container">
      <!-- 左侧LOGO -->
      <div class="logo-section">
        <img src="@/assets/img/顶部LOGO.png" alt="CAREHABI" class="logo" />
      </div>
      
      <div class="header-right">
        <!-- 中间导航菜单 -->
        <nav class="nav-menu">
          <a href="#" class="nav-item">PRODUCTS</a>
          <span class="separator">|</span>
          <a href="#" class="nav-item">NEW</a>
          <span class="separator">|</span>
          <a href="#" class="nav-item">BRAND</a>
          <span class="separator">|</span>
          <a href="#" class="nav-item">SHOP</a>
          <span class="separator">|</span>
          <a href="#" class="nav-item" @click="tapContactUs">CONTACT</a>
        </nav>
        
        <!-- 右侧图标按钮 -->
        <div class="action-buttons">
          <button class="icon-button">
            <img src="@/assets/img/搜索.png" alt="Search" class="icon" />
          </button>
          <button class="icon-button">
            <img src="@/assets/img/购物车.png" alt="Shopping Cart" class="icon" />
          </button>
          <button class="icon-button">
            <img src="@/assets/img/个人信息.png" alt="User Profile" class="icon" />
          </button>
        </div>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-toggle">
        <button @click="toggleMobileMenu" class="menu-button">
          <el-icon v-if="!isMobileMenuOpen" class="menu-icon">
            <Menu />
          </el-icon>
          <el-icon v-else class="menu-icon rotate">
            <Close />
          </el-icon>
        </button>
      </div>
    </div>

    <!-- 移动端菜单列表 -->
    <div class="mobile-menu" :class="{ 'open': isMobileMenuOpen }">
      <nav class="mobile-nav">
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >PRODUCTS</a>
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >NEW</a>
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >BRAND</a>
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >SHOP</a>
        <a href="#" class="mobile-nav-item" @click="tapContactUs" >CONTACT</a>
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >SEARCH</a>
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >CART</a>
        <a href="#" class="mobile-nav-item" @click="toggleMobileMenu" >USER</a>
      </nav>
    </div>

    <!-- 移动端遮罩层 -->
    <div class="mobile-overlay" :class="{ 'open': isMobileMenuOpen }"></div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<script setup>
import { ref, watch, inject } from 'vue'
import { Menu, Close } from '@element-plus/icons-vue'

const showContactModal = inject('showContactModal')
const isMobileMenuOpen = ref(false)

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const tapContactUs = () => {
  showContactModal.value = true
}

// 监听菜单状态，控制body滚动
watch(isMobileMenuOpen, (newValue) => {
  if (newValue) {
    // 菜单打开时，禁止body滚动
    document.body.style.overflow = 'hidden'
  } else {
    // 菜单关闭时，恢复body滚动
    document.body.style.overflow = ''
  }
})
</script>

<style lang="scss" scoped>
.app-header {
  padding: 0;
  position: relative;
  z-index: 1000;
}

.header-container {
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  
  .header-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
  }
}

.logo-section {
  .logo {
    height: 40px;
    width: auto;
  }
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 20px;
  
  .nav-item {
    text-decoration: none;
    color: #333333;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: color 0.3s ease;
    
    &:hover {
      color: #007BFF;
    }
  }
  
  .separator {
    color: #333333;
    font-weight: 600;
  }
}

.action-buttons {
  display: flex;
  align-items: center;
  padding: 0 20px 0 20px;
  background-color: rgb(0, 136, 240);
  transform: translateX(20px);
  border-radius: 19px 0 0 19px;

  .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;

    .icon {
      width: 36px;
      height: 36px;
      display: block;
    }
  }
}

// 移动端菜单按钮
.mobile-menu-toggle {
  display: none;
  
  .menu-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1001;
    
    .menu-icon {
      font-size: 24px;
      color: #333;
      transition: all 0.3s ease;
      transform: rotate(0deg);
      
      &.rotate {
        transform: rotate(180deg);
      }
    }
  }
}

// 移动端菜单列表
.mobile-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateX(-100%);
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 1000;
  max-height: 80vh;
  overflow: hidden;
  
  &.open {
    transform: translateX(0);
    opacity: 1;
  }
  
  .mobile-nav {
    padding: 20px;
    padding-bottom: 40px; // 为底部blur留出空间
    
    .mobile-nav-item {
      display: block;
      padding: 15px 0;
      text-decoration: none;
      color: #333;
      font-weight: 600;
      font-size: 16px;
      text-transform: uppercase;
      border-bottom: 1px solid #f5f5f5;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover {
        color: #007BFF;
      }
    }
  }
  
  // 底部blur遮掩
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: linear-gradient(to bottom, transparent, white);
    pointer-events: none;
    z-index: 1;
  }
}

// 移动端遮罩层
.mobile-overlay {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s ease;

  &.open {
    display: block;
    opacity: 1;
  }
}

// 响应式设计
@media (max-width: 1000px) {
  .app-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
  }
  
  .header-container {
    height: 60px;
  }
  
  .logo-section .logo {
    height: 30px;
  }
  
  .header-right {
    display: none !important;
  }
  
  .mobile-menu-toggle {
    display: block;
  }
  
  .mobile-menu {
    display: block;
  }

  .mobile-overlay.open {
    display: block;
  }
}
</style> 